module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-Regular-f1f4ddbff68ae19309e1128583b7b7f9.woff";